import * as React from "react"
import DropZone from "../drop-zone"
import Notification, { NotificationLevel } from "../notification"
import * as Model from "../../model"
import { updateLocalAuthoritySituation } from "../../service/sfp/situation-service"

export default class CounterUploader extends React.Component<Props, State> {
    private abortController = new AbortController()

    constructor(props: Readonly<Props>) {
        super(props)
        this.state = { dropErrors: [], uploadError: null, uploading: false }
    }

    componentWillUnmount() {
        this.abortController.abort()
    }

    render() {
        const description = "Sélectionner ou glisser un fichier Excel (.xls) dans \
		cette zone."

        return <div className="tile is-parent" style={{ flexGrow: 0 }}>
            {this.renderContent(description)}
        </div>
    }

    private handleFilesChange(files: FileList) {
        if (this.state.uploading) return
        if (!files.length) return
        this.setState({ uploading: true }, () => {
            updateLocalAuthoritySituation(this.props.localAuthority, files[0], this.abortController.signal)
                .then(services => {
                    this.setState({ dropErrors: [], uploadError: null, uploading: false })
                })
                .catch(reason => {
                    this.setState({ dropErrors: [], uploadError: reason, uploading: false })
                })
        })
        if (this.state.uploading == false && !this.state.uploadError) {
            setTimeout(() => window.location.reload(), 1500)
        }

    }

    private renderContent(description: string): React.ReactNode {
        if (this.state.uploading)
            return <progress className="progress is-small is-fullwidth" />

        if (this.state.uploadError) {
            const detail = this.state.uploadError instanceof Error
                ? this.state.uploadError.message
                : this.state.uploadError

            const message = "Une erreur est survenue pendant l'envoi ou le \
			traitement du fichier."

            return <Notification
                detail={detail}
                level={NotificationLevel.Danger}
                message={message}
                onClickCloseButton={() => this.setState({ uploadError: null })} />
        }

        return <div className="tile is-child field">
            <DropZone
                description={description}
                fullWidth
                mimeTypes={["application/vnd.ms-excel"]}
                onDropErrors={dropErrors => this.setState({ dropErrors })}
                onFilesChange={f => this.handleFilesChange(f)} />

            {this.renderDropErrors()}
        </div>
    }

    private renderDropErrors(): React.ReactNode {
        return this.state.dropErrors.map((e, i) =>
            <p className="help is-danger" key={i}>{e}</p>)
    }
}

interface Props {
    localAuthority: Model.LocalAuthority;
    scenario: Model.Scenario;
    situationRecord: Model.SituationRecord[];
}

interface State {
    dropErrors: string[];
    uploadError: any | null;
    uploading: boolean;
}



// WEBPACK FOOTER //
// ./src/component/counter/counter-uploader.tsx